import { LocalStorageKey } from "@/app/vars/Storage";

export class UScriptCallMode {
  public static read(): boolean {
    if (typeof window === "undefined") {
      return false;
    }

    try {
      return window.localStorage.getItem(LocalStorageKey.SCRIPT_CALL_MODE) === "true";
    } catch {
      return false;
    }
  }

  public static write(isCallMode: boolean): void {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.setItem(LocalStorageKey.SCRIPT_CALL_MODE, String(isCallMode));
  }
}
